import { render } from "./ReportFooter.vue?vue&type=template&id=0f780e61&scoped=true"
import script from "./ReportFooter.vue?vue&type=script&lang=js"
export * from "./ReportFooter.vue?vue&type=script&lang=js"

import "./ReportFooter.vue?vue&type=style&index=0&id=0f780e61&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f780e61"],['__file',"src/components/reports/toxicology/ReportFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f780e61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f780e61', __exports__)) {
    console.log('reload')
    api.reload('0f780e61', __exports__)
  }
  
  module.hot.accept("./ReportFooter.vue?vue&type=template&id=0f780e61&scoped=true", () => {
    console.log('re-render')
    api.rerender('0f780e61', render)
  })

}


export default __exports__